import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IconComponent } from '../shared/ui/icon/icon.component';
import { AuthService } from '../services/auth.service';
import { timeout, catchError, of } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, IconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  isLoading = false;
  errorMessage = '';
  returnUrl = '/home';

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    // Return url from route parameters, or default to the warehouse dashboard
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/warehouse-dashboard';
  }

  onLogin() {
    if (!this.email || !this.password) {
      this.errorMessage = 'Enter both your email address and password.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.authService.login({ email: this.email, password: this.password })
      .pipe(
        timeout(30000),
        catchError((error) => {
          let errorMessage = 'An unexpected error occurred. Please try again.';

          if (error.name === 'TimeoutError') {
            errorMessage = 'The request timed out. Please check your connection and try again.';
          } else if (error.message && /authentication required|unauthorized|invalid email or password/i.test(error.message)) {
            // The API's raw auth message isn't actionable — say what to do instead
            errorMessage = 'The email or password is incorrect. Check both and try again.';
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.errorMessage = errorMessage;
          this.isLoading = false;
          this.cdr.detectChanges();

          return of(null);
        })
      )
      .subscribe({
        next: (loginResult) => {
          if (loginResult) {
            this.isLoading = false;
            this.router.navigate([this.returnUrl]);
          }
          // If loginResult is null, the error was already handled in catchError
        },
        error: (error) => {
          // Backup path; catchError above normally handles failures
          this.errorMessage = error.message || 'An unexpected error occurred. Please try again.';
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  onInputChange() {
    // Clear the sign-in error as soon as the user edits a field
    if (this.errorMessage) {
      this.errorMessage = '';
      this.cdr.detectChanges();
    }
  }
}
